module.exports = __webpack_public_path__ + "./img/badnumber.f203c33396ea8422c7024641e6d8f184.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/badnumber.png
// module id = ./src/containers/Briefcase/entry/icons/badnumber.png
// module chunks = 0